// AUTH ACTION TYPES
export const SUCCESSFUL_LOGIN = 'SUCCESSFUL_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const LOGGING_IN = 'LOGGING_IN';

export const SUCCESSFUL_SIGNIN = 'SUCCESSFUL_SIGNIN';
export const ERROR_SIGNIN = 'ERROR_SIGNIN';
export const SIGNING_IN = 'SIGNING_IN';


// Event Action Types
export const FETCHING_EVENT = 'FETCHING_EVENT';
export const ERROR_EVENT = 'ERROR_EVENT';
export const SUCCESS_EVENT = 'SUCCESS_EVENT';
export const ADDING_EVENT = 'ADDING_EVENT';
export const DELETING_EVENT = 'DELETING_EVENT';
export const COMPLETING_EVENT = 'COMPLETING EVENT';
export const UPLOADING_IMAGE = 'UPLOADING_IMAGE';
export const SUCCESS_IMAGE = 'SUCCESS_IMAGE';
export const ERROR_IMAGE = 'ERROR_IMAGE'

// Team Action Types
export const FETCHING_TEAM = 'FETCHING_TEAM';
export const ERROR_TEAM = 'ERROR_FETCHING_TEAM';
export const SUCCESS_TEAM = 'SUCCESS_FETCHING_TEAM';
export const ADDING_TEAM_MEMBER = 'ADDING_TEAM_MEMBER';
export const DELETING_TEAM_MEMBER = 'DELETING_TEAM_MEMBER';

// Todolist Action Types
export const FETCHING_TODO = 'FETCHING_TODO';
export const ERROR_TODO = 'ERROR_FETCHING_TODO';
export const SUCCESS_TODO = 'SUCCESS_FETCHING_TODO';
export const ADDING_TODO = 'ADDING_TODO';
export const DELETING_TODO = 'DELETING_TODO';
export const UPDATING_TODO = 'UPDATING_TODO';
export const MARKING_COMPLETE = 'MARKING_COMPLETE';

// Vendor Action types
export const FETCHING_VENDOR = 'FETCHING_VENDOR';
export const ERROR_VENDOR = 'ERROR_FETCHING_VENDOR';
export const SUCCESS_VENDOR = 'SUCCESS_FETCHING_VENDOR';
export const ADDING_VENDOR = 'ADDING_VENDOR';
export const DELETING_VENDOR = 'DELETING_VENDOR';
export const MARKING_VENDOR_AS_PAID = 'MARKING_VENDOR_COMPLETE';


// error action Types
export const NO_AUTH = 'NO_AUTH';
